var _defs, _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutShape11(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#radial-gradient);\n      }\n\n      .st1 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st3 {\n        fill: url(#radial-gradient7);\n      }\n\n      .st4 {\n        display: none;\n        opacity: .15;\n      }\n\n      .st5 {\n        fill: #1a1a1a;\n      }\n\n      .st6 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st7 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st8 {\n        fill: gray;\n      }\n\n      .st9 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st10 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st11 {\n        fill: #d1d2d1;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 55.52,
    cy: 381.04,
    fx: 55.52,
    fy: 381.04,
    r: 45.51,
    gradientTransform: "translate(-10.56 -333.15) rotate(-.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 45.38,
    cy: 47.84,
    fx: 45.38,
    fy: 47.84,
    r: 33.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 45.31,
    cy: 47.77,
    fx: 45.31,
    fy: 47.77,
    r: 21.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: 45.4,
    cy: 47.81,
    fx: 45.4,
    fy: 47.81,
    r: 31.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#adadad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d4d4d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: -68.03,
    cy: 289.65,
    fx: -68.03,
    fy: 289.65,
    r: 2.95,
    gradientTransform: "translate(-65.71 -233.78) rotate(-33.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: -58.76,
    cy: 289.65,
    fx: -58.76,
    fy: 289.65,
    r: 2.95,
    xlinkHref: "#radial-gradient4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: -68.04,
    cy: 298.88,
    fx: -68.04,
    fy: 298.88,
    r: 2.95,
    xlinkHref: "#radial-gradient4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: -58.76,
    cy: 298.88,
    fx: -58.76,
    fy: 298.88,
    r: 2.95,
    xlinkHref: "#radial-gradient4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M68.12,11.48l-2.98-1.68,1.4-2.47,2.98,1.68-1.4,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M71.92,14.13l-2.78-1.99,1.65-2.31,2.78,1.99-1.65,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M75.41,17.16l-2.55-2.28,1.89-2.12,2.55,2.28-1.89,2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.54,20.55l-2.29-2.54,2.11-1.9,2.29,2.54-2.11,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M81.3,24.27l-2-2.77,2.3-1.66,2,2.77-2.3,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M83.65,28.27l-1.69-2.97,2.47-1.4,1.69,2.97-2.47,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85.54,32.47l-1.36-3.14,2.6-1.13,1.36,3.14-2.6,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.98,36.88l-1.02-3.26,2.71-.84,1.02,3.26-2.71.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87.94,41.42l-.66-3.35,2.78-.55.66,3.35-2.78.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.41,46.04l-.29-3.41,2.83-.24.3,3.4-2.83.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M88.38,50.65l.07-3.42,2.84.06-.07,3.42-2.84-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M87.84,55.26l.44-3.39,2.82.37-.44,3.39-2.81-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.81,59.77l.81-3.32,2.76.67-.81,3.32-2.76-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M85.3,64.14l1.16-3.21,2.67.96-1.16,3.21-2.67-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M83.32,68.34l1.5-3.07,2.55,1.25-1.5,3.07-2.55-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M80.92,72.29l1.82-2.9,2.4,1.51-1.82,2.9-2.41-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M78.08,75.99l2.12-2.68,2.23,1.76-2.12,2.68-2.23-1.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M74.92,79.3l2.39-2.44,2.03,1.99-2.39,2.44-2.03-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M71.35,82.31l2.65-2.16,1.8,2.2-2.65,2.16-1.8-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M67.52,84.88l2.86-1.87,1.55,2.38-2.87,1.87-1.55-2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M63.42,87.03l3.05-1.55,1.28,2.53-3.05,1.55-1.28-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.11,88.74l3.2-1.21,1,2.65-3.2,1.21-1.01-2.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M54.67,89.96l3.31-.86.72,2.75-3.31.86-.72-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M50.09,90.71l3.38-.5.42,2.81-3.38.5-.42-2.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M45.44,90.96l3.42-.14.11,2.84-3.41.14-.11-2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M40.83,90.71l3.41.23-.19,2.83-3.41-.23.19-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M36.26,89.96l3.36.6-.5,2.79-3.37-.6.5-2.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.81,88.72l3.28.96-.8,2.72-3.28-.96.8-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.48,86.99l3.16,1.31-1.09,2.62-3.16-1.31,1.09-2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M23.4,84.83l3,1.64-1.36,2.49-3-1.64,1.36-2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.55,82.24l2.81,1.95-1.62,2.33-2.81-1.95,1.62-2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M16.01,79.25l2.58,2.24-1.86,2.14-2.58-2.24,1.86-2.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12.82,75.9l2.32,2.51-2.08,1.93-2.32-2.51,2.08-1.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M10.03,72.24l2.04,2.74-2.28,1.69-2.04-2.74,2.28-1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.62,68.27l1.73,2.95-2.45,1.44-1.73-2.95,2.45-1.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.66,64.06l1.4,3.12-2.59,1.16-1.4-3.12,2.59-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M4.17,59.7l1.06,3.25-2.7.88-1.06-3.25,2.7-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.14,55.18l.71,3.34-2.78.59-.71-3.34,2.78-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.61,50.59l.35,3.4-2.82.29-.35-3.4,2.82-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M2.58,45.93l-.03,3.42-2.84-.02.02-3.42,2.84.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3.05,41.35l-.39,3.4-2.82-.33.39-3.4,2.82.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M4.01,36.81l-.76,3.33-2.77-.63.76-3.33,2.77.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M5.46,32.42l-1.12,3.23-2.68-.93,1.12-3.23,2.68.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M7.37,28.2l-1.46,3.09-2.57-1.21,1.46-3.09,2.57,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M9.72,24.21l-1.77,2.92-2.43-1.47,1.77-2.92,2.43,1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M12.49,20.49l-2.08,2.71-2.25-1.73,2.08-2.71,2.25,1.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M15.64,17.1l-2.36,2.47-2.05-1.96,2.36-2.47,2.05,1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.12,14.08l-2.61,2.2-1.83-2.17,2.61-2.2,1.83,2.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M22.94,11.43l-2.84,1.91-1.58-2.35,2.84-1.91,1.58,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M27.01,9.22l-3.03,1.59-1.32-2.51,3.03-1.59,1.32,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M31.3,7.46l-3.18,1.26-1.04-2.64,3.18-1.25,1.04,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.75,6.16l-3.3.91-.75-2.74,3.29-.91.75,2.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M40.29,5.36l-3.37.55-.46-2.8,3.37-.55.46,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M44.9,5.04l-3.41.19-.16-2.83,3.41-.19.15,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M49.54,5.22l-3.41-.18.15-2.83,3.41.18-.15,2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M54.11,5.91l-3.37-.55.46-2.8,3.37.55-.46,2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.6,7.09l-3.29-.92.76-2.73,3.29.92-.76,2.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M62.91,8.73l-3.18-1.26,1.05-2.64,3.18,1.26-1.05,2.64Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.89,47.79c.03,25.14-20.33,45.54-45.46,45.56C20.29,93.38-.11,73.02-.14,47.88-.16,22.75,20.19,2.35,45.33,2.32c25.14-.03,45.54,20.33,45.56,45.47Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.12,7.7l5.33.2-.05,1.4-1.79-.07-.16,4.28-1.75-.06.16-4.28-1.79-.06.05-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.86,8.14l1.74.28-.9,5.61-1.74-.28.9-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M52.8,14.18l1.62-5.45,2.8.83c.52.15.9.32,1.15.49.25.17.42.4.52.69.1.29.09.61,0,.96-.09.3-.23.54-.43.73-.19.18-.42.31-.69.37-.17.04-.39.06-.66.04.18.13.31.24.38.33.05.06.11.18.18.37.07.18.12.32.14.41l.34,1.82-1.9-.57-.4-1.93c-.05-.25-.11-.42-.18-.51-.1-.12-.22-.2-.38-.25l-.15-.04-.66,2.21-1.69-.5ZM55.45,11.44l.71.21c.08.02.23.04.47.06.12.01.23-.02.32-.09.1-.07.16-.17.2-.28.05-.18.04-.33-.05-.45-.08-.13-.28-.24-.59-.33l-.74-.22-.33,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M60.97,10.87l4.22,2.08-.53,1.09-2.64-1.3-.4.81,2.45,1.2-.51,1.04-2.45-1.21-.49,1.01,2.72,1.34-.57,1.16-4.3-2.11,2.51-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M43.98,7.24l5.33.19-.05,1.4-1.79-.07-.16,4.28-1.76-.06.16-4.28-1.79-.06.05-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M50.72,7.68l1.74.28-.9,5.61-1.74-.28.9-5.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M52.66,13.72l1.62-5.45,2.8.83c.52.16.9.32,1.15.49.25.17.42.4.52.69.1.29.09.61,0,.96-.09.3-.23.54-.43.72-.19.18-.42.31-.69.38-.17.04-.39.06-.65.04.18.13.31.24.38.33.05.06.11.18.18.37.07.18.12.32.14.41l.34,1.82-1.9-.57-.4-1.93c-.05-.25-.11-.42-.18-.51-.1-.12-.22-.2-.37-.25l-.15-.04-.66,2.21-1.69-.5ZM55.31,10.98l.71.21c.08.02.23.04.47.06.12.01.23-.02.32-.09.1-.07.16-.17.2-.28.05-.18.04-.33-.05-.45-.08-.13-.28-.24-.59-.33l-.74-.22-.33,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M60.83,10.41l4.22,2.08-.53,1.09-2.64-1.3-.4.81,2.45,1.2-.51,1.04-2.45-1.21-.49,1.01,2.72,1.34-.57,1.16-4.3-2.11,2.51-5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M67.91,14.41l4.13,3.38-.89,1.09-1.39-1.13-2.71,3.31-1.36-1.11,2.71-3.31-1.39-1.13.89-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M73.02,18.83l1.22,1.27-4.11,3.92-1.22-1.27,4.11-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.92,24.81l4.58-3.36,1.73,2.36c.32.44.53.8.62,1.09.09.29.09.57,0,.87-.1.29-.29.54-.59.76-.25.19-.51.29-.78.32-.26.03-.52-.01-.78-.12-.16-.07-.34-.19-.55-.36.07.21.1.37.1.49,0,.08-.02.21-.07.4-.05.19-.1.32-.14.41l-.83,1.66-1.17-1.6.85-1.78c.11-.23.17-.4.17-.52,0-.15-.05-.3-.15-.42l-.09-.13-1.86,1.36-1.04-1.42ZM74.68,24.23l.44.6c.05.07.16.17.34.33.09.08.19.12.31.12.12,0,.23-.03.33-.11.15-.11.23-.24.24-.39.01-.15-.08-.36-.27-.62l-.46-.62-.93.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M79.43,27.11l2.11,4.21-1.08.54-1.32-2.63-.81.41,1.23,2.44-1.04.52-1.23-2.44-1,.5,1.36,2.71-1.15.58-2.15-4.28,5.08-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M68.08,13.96l4.13,3.38-.89,1.09-1.39-1.13-2.71,3.31-1.36-1.11,2.71-3.31-1.39-1.13.89-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M73.19,18.38l1.22,1.27-4.11,3.92-1.22-1.27,4.11-3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M71.08,24.36l4.58-3.36,1.73,2.36c.32.44.53.8.62,1.09.09.29.09.58,0,.87-.1.29-.29.54-.59.76-.25.19-.51.29-.78.32-.26.03-.52-.01-.78-.12-.16-.07-.34-.19-.55-.36.07.21.1.37.1.49,0,.08-.02.21-.08.4-.05.19-.1.32-.14.41l-.83,1.66-1.17-1.6.85-1.78c.11-.23.17-.4.16-.51,0-.15-.05-.3-.15-.43l-.09-.12-1.86,1.36-1.04-1.42ZM74.85,23.78l.44.6c.05.06.16.17.34.33.09.08.19.12.31.12.12,0,.23-.03.33-.11.15-.11.23-.24.24-.39.01-.15-.08-.36-.27-.61l-.46-.62-.93.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M79.6,26.66l2.11,4.2-1.08.55-1.32-2.63-.81.4,1.23,2.44-1.04.52-1.23-2.44-1,.5,1.36,2.71-1.15.58-2.15-4.28,5.08-2.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M50.88,87.43l-5.31.53-.14-1.4,1.78-.18-.42-4.26,1.75-.17.42,4.26,1.78-.18.14,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M44.14,87.9l-1.76-.04.14-5.68,1.76.04-.14,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.41,82.19l-.87,5.61-2.89-.45c-.54-.08-.94-.19-1.21-.33-.27-.14-.47-.34-.61-.62-.14-.28-.18-.59-.12-.95.05-.31.16-.57.32-.78.17-.21.38-.36.63-.46.16-.07.38-.11.64-.13-.2-.1-.34-.19-.42-.28-.06-.06-.13-.17-.23-.34-.1-.17-.16-.3-.19-.39l-.59-1.76,1.96.3.66,1.86c.08.24.17.4.25.48.11.11.25.17.41.2l.15.02.35-2.28,1.74.27ZM39.15,85.26l-.73-.11c-.08-.01-.24-.01-.47,0-.12,0-.22.05-.31.13-.09.08-.14.19-.16.31-.03.18,0,.33.11.44.1.11.31.2.62.25l.76.12.18-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M33.76,86.57l-4.46-1.49.38-1.15,2.8.93.29-.86-2.59-.86.37-1.1,2.59.86.35-1.06-2.88-.96.41-1.22,4.55,1.51-1.8,5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M51.08,87.87l-5.31.53-.14-1.4,1.78-.18-.42-4.26,1.75-.17.42,4.26,1.78-.18.14,1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M44.34,88.34l-1.76-.04.14-5.68,1.76.04-.14,5.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M41.61,82.63l-.87,5.61-2.89-.45c-.54-.08-.94-.19-1.21-.33-.27-.14-.47-.34-.61-.62-.14-.28-.18-.59-.12-.95.05-.31.16-.57.32-.78.17-.21.38-.36.63-.46.16-.07.38-.11.64-.13-.2-.1-.34-.19-.42-.28-.06-.06-.13-.17-.23-.34-.1-.17-.16-.3-.19-.39l-.59-1.76,1.96.3.66,1.86c.08.24.17.4.25.48.11.11.25.17.41.2l.15.02.35-2.28,1.74.27ZM39.35,85.7l-.73-.11c-.08-.01-.24-.01-.47,0-.12,0-.22.05-.31.13s-.14.19-.16.31c-.03.18,0,.33.11.44.1.12.31.2.62.25l.76.12.18-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M33.95,87.01l-4.46-1.49.38-1.15,2.79.93.29-.86-2.59-.86.37-1.1,2.59.86.35-1.06-2.88-.96.41-1.22,4.55,1.51-1.79,5.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M26.4,84l-4.55-2.79.73-1.2,1.53.94,2.24-3.65,1.5.92-2.24,3.65,1.53.94-.73,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M20.74,80.3l-1.38-1.1,3.54-4.44,1.38,1.1-3.54,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.02,74.09l-4.09,3.95-2.03-2.1c-.38-.39-.63-.72-.76-.99-.13-.27-.17-.56-.11-.86.06-.3.22-.58.48-.83.23-.22.47-.36.73-.42.26-.06.52-.06.79.01.17.05.37.14.59.29-.09-.2-.15-.36-.17-.47-.01-.08,0-.22.02-.41.02-.19.05-.33.08-.42l.59-1.75,1.38,1.43-.6,1.88c-.08.24-.11.42-.09.53.03.15.09.29.2.4l.11.11,1.66-1.6,1.22,1.27ZM18.37,75.17l-.51-.53c-.06-.06-.18-.15-.38-.28-.1-.07-.21-.09-.33-.08-.12.01-.22.06-.31.15-.13.13-.19.27-.18.42.01.15.13.34.35.57l.54.56.83-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M13.28,72.96l-2.66-3.88,1-.69,1.66,2.43.75-.51-1.54-2.25.96-.65,1.54,2.26.92-.63-1.71-2.5,1.06-.73,2.71,3.95-4.69,3.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.29,84.47l-4.55-2.79.73-1.2,1.53.94,2.24-3.65,1.5.92-2.24,3.65,1.53.94-.73,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M20.64,80.77l-1.38-1.1,3.54-4.44,1.38,1.1-3.54,4.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M21.92,74.56l-4.09,3.95-2.03-2.1c-.38-.39-.63-.72-.76-.99-.13-.27-.17-.56-.11-.86.06-.3.22-.58.48-.83.23-.22.47-.36.73-.42.26-.06.52-.06.79.01.17.05.37.14.59.29-.1-.2-.15-.36-.17-.47-.01-.08,0-.21.02-.41.02-.19.05-.33.08-.42l.59-1.76,1.38,1.43-.6,1.88c-.08.24-.11.42-.09.53.03.15.09.29.2.4l.11.11,1.66-1.6,1.22,1.27ZM18.26,75.64l-.51-.53c-.06-.06-.18-.15-.38-.28-.1-.07-.21-.09-.33-.08-.12.01-.22.06-.31.15-.13.13-.19.27-.18.42.01.15.13.34.35.57l.54.56.83-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.17,73.43l-2.66-3.88,1-.69,1.66,2.43.75-.51-1.54-2.25.96-.66,1.54,2.26.92-.63-1.71-2.5,1.06-.73,2.71,3.95-4.69,3.21Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.03,47.8c.02,18.59-15.03,33.67-33.62,33.69-18.59.02-33.67-15.03-33.69-33.62-.02-18.59,15.03-33.67,33.62-33.69,18.59-.02,33.67,15.03,33.69,33.62Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M67.08,47.75c.01,12.02-9.72,21.78-21.74,21.79-12.02.01-21.78-9.72-21.79-21.74-.01-12.02,9.72-21.78,21.74-21.79,12.02-.01,21.78,9.72,21.79,21.74Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.43,32.83s.04-.02.06-.03c-1.26-2.37-2.81-4.58-4.63-6.57-.02.02-.04.04-.06.06-3.44-3.75-7.82-6.72-12.96-8.5-4.85-1.69-9.83-2.12-14.6-1.49,0-.03,0-.05,0-.08-2.76.37-5.45,1.1-7.99,2.16.01.02.02.04.03.06-8.1,3.35-14.78,10.01-17.88,18.93-5.76,16.58,3.01,34.69,19.59,40.46,16.58,5.76,34.69-3.01,40.45-19.59,3.03-8.72,2.04-17.86-1.99-25.41ZM68.6,65.56l-14.77-10.24c.52-.5.98-1.06,1.4-1.66l14.62,10.14c-.4.61-.82,1.19-1.25,1.76ZM73,57.4c-.45,1.31-1,2.56-1.61,3.75-6.38-3.23-12.41-8.19-14.76-10.39.56-1.81.62-3.66.26-5.41,2.54-2.64,8.24-7.88,14.27-11.32,3.71,6.94,4.62,15.34,1.83,23.36ZM69.84,31.8l-14.03,10.6c-.34-.64-.75-1.23-1.22-1.79l14-10.57c.44.57.86,1.16,1.25,1.77ZM55,20.21c4.74,1.65,8.79,4.4,11.95,7.86-5.41,4.89-12.38,8.78-15.21,10.13-.59-.34-1.21-.64-1.88-.87-.84-.29-1.69-.46-2.54-.55-1.36-2.74-4.58-10.48-5.75-17.93,4.39-.59,8.97-.19,13.44,1.36ZM35.83,75.4l6.23-17.87c.22.09.43.19.65.26.47.16.94.28,1.42.38l-6.23,17.86c-.69-.18-1.38-.39-2.07-.63ZM38.95,19.31l4.98,17.67c-.71.16-1.4.38-2.06.68l-5.02-17.79c.69-.21,1.39-.4,2.09-.56ZM34.33,20.78c2.93,7.06,4.16,15.72,4.4,19.01-1.01.98-1.83,2.16-2.41,3.53-2.55.31-11.7.64-19.58-1.13.26-1.33.61-2.66,1.07-3.98,2.86-8.24,9.04-14.37,16.52-17.44ZM16.33,44.99l19.19,1.37c-.08.73-.09,1.45-.02,2.17l-19.3-1.38c.02-.72.06-1.44.13-2.16ZM16.33,50.7c7.36-.97,16.07.25,19.96,1.04.7,1.67,1.81,3.16,3.26,4.31-.73,3.34-3.11,11.56-6.9,18.04-9.31-4.5-15.33-13.5-16.32-23.39ZM41.13,76.7c1.28-7.87,4.84-16.07,6.06-18.35,1.38-.12,2.71-.49,3.93-1.1,2.66,1.24,10.03,5.35,15.62,10.5-6.46,6.89-16.02,10.37-25.61,8.94Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M72.31,30.89s.04-.02.05-.03c-1.42-2.27-3.13-4.37-5.09-6.23-.02.02-.04.04-.05.06-3.69-3.49-8.28-6.15-13.53-7.57-4.96-1.34-9.96-1.42-14.67-.45,0-.03-.01-.05-.01-.08-2.73.56-5.36,1.48-7.82,2.72.01.02.02.04.03.06-7.84,3.91-14.04,11.03-16.5,20.15-4.58,16.95,5.45,34.39,22.4,38.97,16.95,4.58,34.39-5.45,38.97-22.4,2.41-8.91.77-17.96-3.78-25.2ZM69.8,63.88l-15.45-9.17c.48-.54.91-1.12,1.28-1.76l15.3,9.08c-.35.63-.73,1.25-1.12,1.85ZM73.61,55.42c-.36,1.34-.81,2.62-1.34,3.86-6.6-2.77-12.95-7.29-15.46-9.32.43-1.85.36-3.7-.12-5.41,2.35-2.81,7.66-8.44,13.44-12.3,4.19,6.66,5.69,14.98,3.48,23.17ZM68.65,30.11l-13.25,11.56c-.39-.61-.84-1.18-1.34-1.7l13.22-11.53c.48.54.94,1.1,1.37,1.67ZM53.02,19.6c4.85,1.31,9.07,3.76,12.48,6.99-5.05,5.26-11.73,9.63-14.46,11.17-.61-.3-1.26-.55-1.94-.73-.86-.23-1.72-.34-2.57-.36-1.55-2.63-5.31-10.13-7.01-17.48,4.33-.89,8.93-.82,13.5.41ZM37.8,76.01l4.96-18.27c.22.08.44.16.67.22.48.13.96.21,1.44.28l-4.95,18.25c-.7-.14-1.41-.29-2.11-.48ZM36.96,19.84l6.22,17.27c-.7.21-1.37.48-2,.82l-6.26-17.39c.67-.26,1.36-.49,2.05-.7ZM32.45,21.63c3.42,6.84,5.26,15.39,5.73,18.66-.94,1.05-1.68,2.29-2.16,3.69-2.52.49-11.63,1.46-19.61.26.17-1.35.42-2.69.79-4.04,2.27-8.42,8.01-14.97,15.25-18.56ZM16.2,47.06h19.24c-.03.74.02,1.46.13,2.17h-19.35c-.03-.73-.04-1.45-.02-2.17ZM16.61,52.74c7.28-1.49,16.05-.89,19.98-.37.82,1.62,2.03,3.02,3.56,4.07-.49,3.39-2.28,11.75-5.6,18.48-9.61-3.83-16.25-12.38-17.94-22.18ZM43.18,76.93c.72-7.94,3.69-16.37,4.75-18.73,1.37-.21,2.67-.68,3.84-1.38,2.74,1.05,10.38,4.62,16.32,9.37-5.95,7.33-15.25,11.48-24.92,10.73Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.55,48.53h0c-1.35.9-3.19.53-4.09-.81h0c-.9-1.35-.53-3.19.81-4.09h0c1.35-.9,3.19-.53,4.09.81h0c.9,1.35.53,3.19-.81,4.09Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.27,43.38h0c-1.35.9-3.19.53-4.09-.81h0c-.9-1.35-.53-3.19.81-4.09h0c1.35-.9,3.19-.53,4.09.81h0c.9,1.35.53,3.19-.81,4.09Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M46.68,56.21h0c-1.35.9-3.19.53-4.09-.81h0c-.9-1.35-.53-3.19.81-4.09h0c1.35-.9,3.19-.53,4.09.81h0c.9,1.35.53,3.19-.81,4.09Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54.39,51.05h0c-1.35.9-3.19.53-4.09-.81h0c-.9-1.35-.53-3.19.81-4.09h0c1.35-.9,3.19-.53,4.09.81h0c.9,1.35.53,3.19-.81,4.09Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutShape11);
export default __webpack_public_path__ + "static/media/about_shape1-1.0eda67fd730528cfec0b025eb44f842f.svg";
export { ForwardRef as ReactComponent };